import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router';

//MaterialUI Imports
import {
    Button,
    CardContent,
    CardHeader,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    Stack,
    Alert,
    Snackbar,
    Pagination,
    Grid,
    Card,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    TextField,
    InputAdornment
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';

//Icon Imports
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PeopleIcon from '@mui/icons-material/People';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
//import axios from 'axios';

//Project Imports
import MainCard from 'ui-component/cards/MainCard';
import EmployeeForm from './EmployeeForm';
import useEmployeeService from 'services/useEmployeeService';
import NoResults from 'assets/images/noresults.png';
import { convertDateToLocal } from 'utils/DateOperations';
//import { locations } from 'store/constant';
import PaginationComponent from 'ui-component/Pagination/PaginationComponent';
import useLocationService from 'services/useLocationService';

//third party
//import { Tree, TreeNode } from 'react-organizational-chart';

const Employees = () => {
    //Constants
    const theme = useTheme();
    const { getEmployees, softDeleteEmployee } = useEmployeeService();
    const { getLocationList } = useLocationService();
    const [searchParams, setSearchParams] = useSearchParams();
    const pageSize = 50;
    //States

    const [employeeDetails, setEmployeeDetails] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState('');

    const [openForm, setOpenForm] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openToast, setOpenToast] = useState(false);

    const [isError, setIsError] = useState();
    const [selectedLocation, setSelectedLocation] = useState(-1);

    const [count, setCount] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [currentSkipValue, setCurrentSkipValue] = useState(0);

    const [searchText, setSearchText] = useState('');
    const [refresh, setRefresh] = useState(true);
    const [location, setLocation] = useState();
    //Methods
    const handleCancel = () => {
        setOpenForm(false);
    };

    const handleSave = () => {
        getEmployeeList();
    };

    const handleCloseToast = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenToast(false);
    };

    const getEmployeeList = () => {
        getEmployees(searchText, -1, selectedLocation, currentSkipValue, pageSize)
            .then((response) => {
                console.log(searchText, -1, selectedLocation, currentSkipValue, pageSize);
                setCount(response.data.count);
                setEmployeeDetails(response.data.users);
            })
            .catch((error) => setIsError(error.message));
    };

    const handleDelete = () => {
        softDeleteEmployee(selectedEmployee.id)
            .then((response) => {
                getEmployeeList();
                setOpenToast(true);
                setOpenDeleteDialog(false);
            })
            .catch((error) => {
                console.log(error);
                setOpenDeleteDialog(false);
            });
    };

    const handleChange = (e) => {
        setSelectedLocation(e.target.value);
    };
    const handleGetLocation = () => {
        getLocationList()
            .then((response) => {
                console.log(response);
                setLocation(response.data.locations);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };

    //useEffects
    useEffect(() => {
        //setEmployeeDetails(undefined);
        getEmployeeList();
        handleGetLocation();
    }, [currentPage, selectedLocation, searchText]);

    return (
        <>
            <MainCard>
                <CardHeader
                    avatar={<PeopleIcon color="primary" />}
                    sx={{ padding: 0 }}
                    title="Employee List"
                    action={
                        <Grid container>
                            <Grid item sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    startIcon={<AddIcon />}
                                    align="right"
                                    onClick={() => {
                                        setSelectedEmployee({
                                            id: 0,
                                            salutation: 0,
                                            firstName: '',
                                            middleName: '',
                                            lastName: '',
                                            email: '',
                                            mobileNumber: '',
                                            reportingTo: 0,
                                            haveVehicle: false,
                                            roomRent: 0,
                                            locationId: 0
                                        });
                                        setOpenForm(true);
                                    }}
                                >
                                    Add New Employee
                                </Button>
                            </Grid>
                        </Grid>
                    }
                />
                <Divider sx={{ marginY: 3 }} />
                <Grid item align="right" sx={{ display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}>
                    <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<AddIcon />}
                        align="right"
                        onClick={() => {
                            setSelectedEmployee({
                                id: 0,
                                salutation: 0,
                                firstName: '',
                                middleName: '',
                                lastName: '',
                                email: '',
                                mobileNumber: '',
                                reportingTo: 0,
                                haveVehicle: 0,
                                roomRent: 0,
                                locationId: 0
                            });
                            setOpenForm(true);
                        }}
                    >
                        Add New Employee
                    </Button>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <TextField
                            size="small"
                            fullWidth
                            placeholder="Search by name or mobile number"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                )
                            }}
                            onChange={(event) => {
                                setSearchText(event.target.value);
                            }}
                            value={searchText}
                        ></TextField>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3}>
                        <Button
                            variant="contained"
                            loading={refresh}
                            onClick={() => {
                                getEmployeeList();
                                setRefresh(true);
                            }}
                            startIcon={<RefreshIcon />}
                        >
                            Refresh
                        </Button>
                    </Grid>
                    <Grid item sm={3} xs={12}>
                        <FormControl fullWidth>
                            <InputLabel>Location</InputLabel>
                            <Select
                                labelId="location-select-label"
                                id="location-select"
                                label="Location"
                                size="small"
                                fullWidth
                                name="location"
                                value={selectedLocation}
                                onChange={handleChange}
                            >
                                <MenuItem value={-1}>All</MenuItem>
                                {location?.map((location, index) => {
                                    return (
                                        <MenuItem key={index} value={location.id}>
                                            <Stack direction="column">
                                                <Typography>{location.city}</Typography>
                                            </Stack>
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        {employeeDetails != undefined && (
                            <>
                                {count != undefined && count != 0 ? (
                                    <Pagination
                                        count={Math.ceil(count / pageSize)}
                                        variant="outlined"
                                        shape="rounded"
                                        showFirstButton
                                        showLastButton
                                        color="primary"
                                        sx={{ marginY: 2 }}
                                        onChange={(event, page) => {
                                            setCurrentSkipValue((page - 1) * pageSize);
                                            setCurrentPage(page);
                                        }}
                                    />
                                ) : null}
                            </>
                        )}
                    </Grid>
                </Grid>

                {employeeDetails != undefined || employeeDetails != null ? (
                    <>
                        {employeeDetails?.length == 0 ? (
                            <Grid align="center" sx={{ mt: 5, mb: 5 }}>
                                <img src={NoResults} alt="No Result" width="150px" />
                                <Typography variant="h4" fontWeight={100}>
                                    There are no employee details found
                                </Typography>
                            </Grid>
                        ) : (
                            <>
                                <Grid item sm={12} md={12} lg={12} sx={{ display: { xs: 'none', sm: 'block', md: 'block', xl: 'block' } }}>
                                    <TableContainer>
                                        <Table
                                            sx={{
                                                border: 'solid',
                                                borderWidth: 1,
                                                borderColor: 'divider'
                                            }}
                                        >
                                            <TableHead sx={{ backgroundColor: theme.palette.primary.light }}>
                                                <TableCell sx={{ width: 60 }}>
                                                    <Typography variant="h5">Sr.No.</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    <Typography variant="h5">Employee</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 120 }}>
                                                    <Typography variant="h5">Contact Details</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 120 }}>
                                                    <Typography variant="h5">Joining Date</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 180 }}>
                                                    <Typography variant="h5">Reporting To</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 120 }}>
                                                    <Typography variant="h5">Location</Typography>
                                                </TableCell>
                                                <TableCell sx={{ width: 110 }}></TableCell>
                                            </TableHead>
                                            <TableBody>
                                                {employeeDetails?.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {(currentPage - 1) * pageSize + index + 1}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <Typography sx={{ color: theme.palette.primary.main, fontWeight: '700' }}>
                                                                {row.salutationDisplay} {row.firstName} {row.middleName} {row.lastName}
                                                            </Typography>
                                                            <Typography variant="caprtion">{row.roleDisplay}</Typography>
                                                        </TableCell>
                                                        {/* <TableCell align="left">{row.role}</TableCell> */}
                                                        <TableCell align="left">
                                                            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
                                                                {row.email}
                                                            </Typography>{' '}
                                                            <Typography variant="body2" sx={{ color: theme.palette.grey[700] }}>
                                                                +91-{row.mobileNumber}
                                                            </Typography>
                                                        </TableCell>
                                                        {/* <TableCell align="left">{row.mobileNumber}</TableCell> */}
                                                        <TableCell align="left">{convertDateToLocal(row.joiningDate)}</TableCell>
                                                        <TableCell align="left">{row.reportingToName}</TableCell>
                                                        <TableCell align="left">{row.locationName}</TableCell>
                                                        <TableCell align="right">
                                                            <Tooltip title="Edit Employee details">
                                                                <IconButton
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    disabled={row.email == 'navbharat2009@gmail.com'}
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setSelectedEmployee(row);
                                                                        setOpenForm(true);
                                                                    }}
                                                                >
                                                                    <EditIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Delete Employee">
                                                                <IconButton
                                                                    size="small"
                                                                    disabled={row.email == 'navbharat2009@gmail.com'}
                                                                    color="error"
                                                                    onClick={() => {
                                                                        setSelectedEmployee(row);
                                                                        setOpenDeleteDialog(true);
                                                                    }}
                                                                >
                                                                    <DeleteIcon fontSize="inherit" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                {employeeDetails?.map((row, index) => (
                                    <Grid
                                        key={index}
                                        item
                                        xs={12}
                                        sx={{ mb: 0.5, display: { xs: 'block', sm: 'none', md: 'none', xl: 'none' } }}
                                    >
                                        <Card sx={{ p: 2 }} variant="outlined" key={index}>
                                            <Stack justifyContent="space-between" direction="row" alignItems="center" spacing={2}>
                                                <Typography variant="h5">Name:</Typography>
                                                <Typography>
                                                    {' '}
                                                    {row.salutationDisplay} {row.firstName} {row.middleName} {row.lastName}
                                                </Typography>
                                            </Stack>

                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Role:</Typography>
                                                <Typography>{row.role}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Email Address:</Typography>
                                                <Typography>{row.email}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Mobile Number:</Typography>
                                                <Typography>{row.mobileNumber}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Joining Date:</Typography>
                                                <Typography>{new Date(row.joiningDate).toLocaleDateString('hi-IN')}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Reporting To:</Typography>
                                                <Typography>{row.reportingTo}</Typography>
                                            </Stack>
                                            <Stack justifyContent="space-between" direction="row" sx={{ mt: 2 }}>
                                                <Typography variant="h5">Location:</Typography>
                                                <Typography>{row.locationName}</Typography>
                                            </Stack>

                                            <Divider sx={{ mt: 1 }} />
                                            <Stack justifyContent="flex-end" direction="row" alignItems="right" sx={{ mt: 2 }}>
                                                <Tooltip title="Edit Employee details">
                                                    <IconButton
                                                        variant="outlined"
                                                        color="primary"
                                                        disabled={row.email == 'navbharat2009@gmail.com'}
                                                        size="small"
                                                        onClick={() => {
                                                            setSelectedEmployee(row);
                                                            setOpenForm(true);
                                                        }}
                                                    >
                                                        <EditIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete Employee">
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        disabled={row.email == 'navbharat2009@gmail.com'}
                                                        onClick={() => {
                                                            setSelectedEmployee(row);
                                                            setOpenDeleteDialog(true);
                                                        }}
                                                    >
                                                        <DeleteIcon fontSize="inherit" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Stack>
                                        </Card>
                                    </Grid>
                                ))}
                            </>
                        )}
                    </>
                ) : (
                    <Stack direction="column" justifyContent="Center" alignItems="center" spacing={2} sx={{ marginY: 3 }}>
                        <Typography variant="h4" textAlign="center">
                            Getting Employee List...
                        </Typography>
                        <CircularProgress />
                    </Stack>
                )}
            </MainCard>

            <Dialog open={openForm} onClose={handleCancel} fullWidth maxWidth="md">
                <DialogContent>
                    <EmployeeForm
                        employees={employeeDetails?.users}
                        onSave={handleSave}
                        onCancel={handleCancel}
                        selectedEmployee={selectedEmployee}
                    />
                </DialogContent>
            </Dialog>

            <Dialog
                open={openDeleteDialog}
                onClose={() => {
                    setOpenDeleteDialog(false);
                }}
                fullWidth
            >
                <DialogTitle>
                    <Typography variant="h4" color={theme.palette.secondary.dark}>
                        Delete Employee Details
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="h5" color={theme.palette.error}>
                        Are you sure you want to delete this employee details ?
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        onClick={() => {
                            handleDelete();
                        }}
                        variant="contained"
                    >
                        Yes
                    </LoadingButton>
                    <LoadingButton
                        onClick={() => {
                            setOpenDeleteDialog(false);
                        }}
                        variant="outlined"
                    >
                        No
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <Snackbar open={openToast} autoHideDuration={6000} onClose={handleCloseToast}>
                <Alert onClose={handleCloseToast} severity="success" sx={{ width: '100%', backgroundColor: theme.palette.success.main }}>
                    <Typography sx={{ color: theme.palette.grey[50] }}> Employee data deleted succesfully!!</Typography>
                </Alert>
            </Snackbar>
        </>
    );
};

export default Employees;
